function openModalBracingDialog() {
    $('#modal-bracing-dialog').modal('show');
}

function closeModalBracingDialog() {
    if (activeProject.beamController.isEquallySpacedBracing()) {
        if ($("#equal-bracing-spacing-input").valid() && $("#equal-bracing-start-input").valid()) {
            activeProject.beamController.addEquallySpacedBraces(
                wsParseLength($("#equal-bracing-spacing-input").val()),
                wsParseLength($("#equal-bracing-start-input").val()));
            $('#modal-bracing-dialog').modal('hide');
        }
    } else {
        $("#modal-bracing-dialog").trigger( 'ws_redraw' );
        $('#modal-bracing-dialog').modal('hide');
    }
}

function initBracingDialog() {
    $('#equal-bracing-table').hide();
    $('#custom-bracing-form').hide();
    $("#equal-bracing-spacing-input").val('24"');
    $("#equal-bracing-start-input").val('0"');

    jQuery.validator.addMethod("validBraceSpacing", function(value, element) {
        var spacing = wsParseLength(value);
        return !isNaN(spacing) && spacing > 0 && spacing <= activeProject.beam.TotalLength();
    }, "Brace spacing must be larger than 0 and less than or equal to the total length of the beam.");

    jQuery.validator.addMethod("validBraceLocation", function(value, element) {
        var spacing = wsParseLength(value);
        return !isNaN(spacing) && spacing >= 0 && spacing <= activeProject.beam.TotalLength();
    }, "Brace location must be greater than or equal to 0 and less than or equal to the total length of the beam.");

    $( "#equal-bracing-form" ).validate({
        rules: {
            'equal-bracing-spacing-input': {
                required: true,
                validLengthUnit: true,
                validBraceSpacing: true
            },
            'equal-bracing-start-input' : {
                required: true,
                validLengthUnit: true,
                validBraceLocation: true
            },
        }
    });

    $( "#custom-bracing-form" ).validate({
        rules: {
            'new-brace-location-input': {
                required: true,
                validLengthUnit: true,
                validBraceLocation: true
            }
        }
    });
}

function configureBracingDialog() {
    if (activeProject.design.bracingType === 'continuous') {
        $('#continuous-bracing-button').prop('checked', true);
        $('#equal-bracing-table').hide();
        $('#custom-bracing-form').hide();
    } else if (activeProject.design.bracingType === 'equal') {
        $('#equally-spaced-bracing-button').prop('checked', true);
        $('#equal-bracing-table').show();
        $('#custom-bracing-form').hide();
        updateEquallySpacedBracingForm();
    } else if (activeProject.design.bracingType == 'custom') {
        $('#custom-spaced-bracing-button').prop('checked', true);
        $('#equal-bracing-table').hide();
        $('#custom-bracing-form').show();
        updateCustomBracingTable();
    } else if (activeProject.design.bracingType == 'unbraced') {
        $('#unbraced-bracing-button').prop('checked', true);
        $('#equal-bracing-table').hide();
        $('#custom-bracing-form').hide();
    }
}

function continuousBracingSelected() {
    $('#equal-bracing-table').hide();
    $('#custom-bracing-form').hide();
    activeProject.beamController.updateBracingType("continuous");
    $("#modal-bracing-dialog").trigger( 'ws_redraw' );
    $('#modal-bracing-dialog').trigger( 'bracing-type-changed' );
}

function equallySpacedBracingSelected() {
    $('#equal-bracing-table').show();
    $('#custom-bracing-form').hide();
    activeProject.beamController.updateBracingType("equal");
    updateEquallySpacedBracingForm();
    $("#modal-bracing-dialog").trigger( 'ws_redraw' );
    $('#modal-bracing-dialog').trigger( 'bracing-type-changed' );
}

function customBracingSelected() {
    $('#equal-bracing-table').hide();
    $('#custom-bracing-form').show();
    activeProject.beamController.updateBracingType("custom");
    updateCustomBracingTable();
    $("#modal-bracing-dialog").trigger( 'ws_redraw' );
    $('#modal-bracing-dialog').trigger( 'bracing-type-changed' );
}

function unbracedBracingSelected() {
    $('#equal-bracing-table').hide();
    $('#custom-bracing-form').hide();
    activeProject.beamController.updateBracingType("unbraced");
    $("#modal-bracing-dialog").trigger( 'ws_redraw' );
    $('#modal-bracing-dialog').trigger( 'bracing-type-changed' );
}

function updateEquallySpacedBracingForm() {
    $('#equal-bracing-spacing-input').val(showSmallLengthWithUnits(activeProject.design.getBraceSpacing()));
    $('#equal-bracing-start-input').val(showSmallLengthWithUnits(activeProject.design.getBracingStartLocation()));
}

function updateCustomBracingTable() {
    // loop over braces and build a table showing them...
    var design = activeProject.design;
    var str = '<table class="table">', i = 0;
    for( i in design.customBraces ) {
        if(design.customBraces[i].isSupport) {
            str += "<tr class='grayout'>";
            str += "<td style='width:100px;'>";
            str += "<span class='ws-ui-disabled-font'>Brace @</span>";
            str += "</td>";
            str += "<td style='width:100px;' id='brace_"+i+"'>"+ showFeetInches(design.customBraces[i].x) +"</td>";
            str += "<td style='width:100px;'><span><em>Support</em></span></td></tr>";
        } else {
            str += "<tr>";
            str += "<td style='width:100px;'>";
            str += "Brace @";
            str += "</td>";
            str += "<td style='width:100px;' id='brace_"+i+"'>"+ showFeetInches(design.customBraces[i].x) +"</td>";
            str += "<td style='width:100px;'><button type='button' class='btn btn-sm btn-danger' data-toggle='modal' onclick='removeBrace(" + i + ");'>Remove</button></td></tr>";
        }
    }
    str += "<tr class='info'><td colspan=3>Note: Supports assumed braced.</td></tr>";
    str += "</table>";
    $('#custom-bracing-table').html(str);
}

function addBrace() {
    if ($("#new-brace-location-input").valid()) {
        //console.log('add');
        var brace = wsParseLength($("#new-brace-location-input").val());
        activeProject.beamController.addBrace(brace, false);
        updateCustomBracingTable();
    }
}

function removeBrace( index ) {
    activeProject.beamController.removeBrace( index );
    updateCustomBracingTable();
}
